import { UnsupportedError } from './custom-errors';
export default function getErrorResult({ task, error }) {
    if (error instanceof UnsupportedError) {
        return {
            type: 'error',
            taskId: task.taskId,
            reason: 'unsupported',
            message: error.message,
        };
    }
    return {
        type: 'error',
        taskId: task.taskId,
        reason: 'unhandled',
        message: null,
    };
}
